import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ICalculator = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <rect
              x="0.75"
              y="0.75"
              width="19.5"
              height="19.5"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              
            />
            <line
              x1="4.84595"
              y1="15.5543"
              x2="8.07672"
              y2="15.5543"
              stroke={props.color??"#37474F"}
              strokeWidth="1.2"
            />
            <line
              x1="4.84595"
              y1="10.7066"
              x2="8.07672"
              y2="10.7066"
              stroke={props.color??"#37474F"}
              strokeWidth="1.2"
              fill={props.color}
            />
            <line
              x1="4.84619"
              y1="5.86094"
              x2="8.07696"
              y2="5.86094"
              stroke={props.color??"#37474F"}
              strokeWidth="1.2"
              fill={props.color}
            />
            <line
              x1="9.69238"
              y1="15.5543"
              x2="16.1539"
              y2="15.5543"
              stroke={props.color??"#37474F"}
              strokeWidth="1.2"
              fill={props.color}
            />
            <line
              x1="9.69238"
              y1="10.7066"
              x2="16.1539"
              y2="10.7066"
              stroke={props.color??"#37474F"}
              strokeWidth="1.2"
              fill={props.color}
            />
            <line
              x1="9.69238"
              y1="5.86094"
              x2="16.1539"
              y2="5.86094"
              stroke={props.color??"#37474F"}
              strokeWidth="1.2"
              fill={props.color}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ICalculator;
